import { createActions, createReducer } from 'reduxsauce'

import ConsultaBemService from '../../servicos/ConsultaBemService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaBemInicio: [],
    buscaConsultaBemSucesso: ['consultaBem'],
    buscaConsultaBemErro: ['erro'],
    limpar: [],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
}

// Ação para busca completa
Creators.buscaConsultaBem = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaBemInicio())
        let serv = new ConsultaBemService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaBemSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaBemErro(error)))
    }
}

const buscaConsultaBemInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaBemErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaBemSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.consultaBem.resultado, dataSincronizacaoDados: action.consultaBem.dataSincronizacaoDados, carregando: false }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_BEM_INICIO]: buscaConsultaBemInicio,
    [Types.BUSCA_CONSULTA_BEM_ERRO]: buscaConsultaBemErro,
    [Types.BUSCA_CONSULTA_BEM_SUCESSO]: buscaConsultaBemSucesso,
    [Types.LIMPAR]: limpar,
})
